import { CreateLazyLoadedClientComponent } from "../../components/common/LazyLoadComponentForClient";
import { GetClientSubModuleLocation } from "../../utils/client";

const path = GetClientSubModuleLocation("APP_ANALYTICS", "INDEX");

export default CreateLazyLoadedClientComponent(() =>
  import(`./clientVariations/${path}`),
);
